"use client";

import { Trash2, Undo2 } from "lucide-react";
import { useNotebook } from "@/lib/notebook/core/store";

export function DeletedStatusBanner() {
  const restoreFromTrash = useNotebook((s) => s.restoreFromTrash);
  const restoreRequiresFolder = useNotebook((s) => s.restoreRequiresFolder);
  const parentFolderName = useNotebook((s) => s.parentFolderName);
  const restoreBusy = useNotebook((s) => s.restoreBusy);

  const hint = restoreRequiresFolder
    ? parentFolderName
      ? `Restore the "${parentFolderName}" folder to edit this note again.`
      : "Restore its folder from Trash to edit this note again."
    : "View only — restore from Trash to edit again.";

  return (
    <div className="nb-deleted-status" role="status" aria-live="polite">
      <span className="nb-deleted-status__glyph" aria-hidden>
        <Trash2 size={14} strokeWidth={2} />
      </span>
      <div className="nb-deleted-status__copy">
        <span className="nb-deleted-status__title">This note has been deleted</span>
        <span className="nb-deleted-status__hint">{hint}</span>
      </div>
      {restoreFromTrash ? (
        <button
          type="button"
          className="nb-deleted-status__action"
          disabled={restoreBusy}
          onClick={() => void restoreFromTrash()}
        >
          <Undo2 size={14} strokeWidth={2} aria-hidden />
          {restoreRequiresFolder ? "Restore folder" : "Restore note"}
        </button>
      ) : null}
    </div>
  );
}
